import { DEFAULT_BORDER } from 'constants/global';

const samePaddings = {
  laptop: '48px 0 48px 80px',
  md: '24px 0px 24px 32px',
  mobile: '16px 24px 24px',
};
const sameStyles = {
  h: { mobile: 'fit-content', md: '320px', laptop: '490px', desktop: '600px' },
  minH: { mobile: '610px', xms: 'unset' },
  textContainerProps: {
    height: { md: 'full' },
    maxW: '730px',
    justify: { tablet: 'end', laptop: 'start' },
    pt: { laptop: '100px', desktop: '110px' },
    gap: { mobile: '16px', laptop: '24px' },
  },
  contentContainerProps: { h: 'full', flexDir: { mobile: 'column-reverse', md: 'row' } },
  tagProps: { hideBelow: 'mobile' },
};

export const supportPagesCardsStyles = {
  1: {
    bgColor: 'white',
    border: DEFAULT_BORDER,
    borderColor: 'bg.gray',
    p: { desktop: '48px 0px 48px 80px', ...samePaddings },
    imgProps: {
      w: { desktop: '554px', xxl: '433px', mobile: '284px' },
      h: { desktop: '504px', xxl: '394px', mobile: '272px' },
      mt: { tablet: '-24px' },
    },
    ...sameStyles,
  },
  2: {
    bgColor: 'bg.gray',
    p: { desktop: '48px 28px 48px 80px', ...samePaddings },
    imgProps: {
      w: { desktop: '526px', xxl: '411px', mobile: '284px' },
      h: { desktop: '504px', xxl: '394px', mobile: '272px' },
      mt: { tablet: '-18px' },
      transform: { tablet: 'translateY(8px)', xxl: 'translateY(16px)', desktop: 'translateY(5px)' },
    },
    ...sameStyles,
  },
  3: {
    bgColor: 'bg.accent',
    p: { desktop: '48px 28px 48px 80px', ...samePaddings },
    imgProps: {
      w: { desktop: '526px', xxl: '411px', mobile: '284px' },
      h: { desktop: '504px', xxl: '394px', mobile: '272px' },
      mt: { tablet: '-24px' },
    },
    ...sameStyles,
  },
};
